import sentryConfig from '@dvcorg/gatsby-theme-iterative/sentry-config'
import * as Sentry from '@sentry/gatsby'

Sentry.init(sentryConfig)
